import { call, put, select, takeLeading } from 'redux-saga/effects';
import { invalidateTags } from '../../../../store/api/apiSlice';
import apiConfig from '../../../../apiConfig';
import { loginSelector } from '../../../userFarmSlice';
import { axios, getHeader } from '../../../saga';
import { createAction } from '@reduxjs/toolkit';
import {
  deleteFenceSuccess,
  editFenceSuccess,
  getLocationObjectFromFence,
  postFenceSuccess,
} from '../../../fenceSlice';
import history from '../../../../history';
import { canShowSuccessHeader, setSuccessMessage } from '../../../mapSlice';
import i18n from '../../../../locales/i18n';

export const postFenceLocation = createAction(`postFenceLocationSaga`);

export function* postFenceLocationSaga({ payload: data }) {
  const formData = data.formData;
  const { locationURL } = apiConfig;
  let { user_id, farm_id } = yield select(loginSelector);
  formData.farm_id = farm_id;
  const header = getHeader(user_id, farm_id);
  const locationObject = getLocationObjectFromFence(formData);

  try {
    const result = yield call(
      axios.post,
      `${locationURL}/${locationObject.figure.type}`,
      locationObject,
      header,
    );
    yield put(postFenceSuccess(result.data));
    yield put(invalidateTags(['Locations']));
    yield put(
      setSuccessMessage([i18n.t('FARM_MAP.MAP_FILTER.FENCE'), i18n.t('message:MAP.SUCCESS_POST')]),
    );
    yield put(canShowSuccessHeader(true));
    history.push('/map');
  } catch (e) {
    history.push(
      {
        pathname: history.location.pathname,
      },
      {
        error: `${i18n.t('message:MAP.FAIL_POST')} ${i18n
          .t('FARM_MAP.MAP_FILTER.FENCE')
          .toLowerCase()}`,
      },
    );
    console.log(e);
  }
}

export const editFenceLocation = createAction(`editFenceLocationSaga`);

export function* editFenceLocationSaga({ payload: data }) {
  const { formData, location_id, figure_id } = data;
  const { locationURL } = apiConfig;
  let { user_id, farm_id } = yield select(loginSelector);
  formData.farm_id = farm_id;
  const header = getHeader(user_id, farm_id);
  const locationObject = getLocationObjectFromFence({ ...formData, location_id, figure_id });

  try {
    const result = yield call(
      axios.put,
      `${locationURL}/${locationObject.figure.type}/${location_id}`,
      locationObject,
      header,
    );
    yield put(editFenceSuccess(result.data));
    yield put(invalidateTags(['Locations']));
    yield put(
      setSuccessMessage([i18n.t('FARM_MAP.MAP_FILTER.FENCE'), i18n.t('message:MAP.SUCCESS_PATCH')]),
    );
    yield put(canShowSuccessHeader(true));
    history.push({ pathname: '/map' });
  } catch (e) {
    history.push(
      {
        pathname: history.location.pathname,
      },
      {
        error: `${i18n.t('message:MAP.FAIL_PATCH')} ${i18n
          .t('FARM_MAP.MAP_FILTER.FENCE')
          .toLowerCase()}`,
      },
    );
    console.log(e);
  }
}

export const deleteFenceLocation = createAction(`deleteFenceLocationSaga`);

export function* deleteFenceLocationSaga({ payload: data }) {
  const { location_id } = data;
  const { locationURL } = apiConfig;
  let { user_id, farm_id } = yield select(loginSelector);
  const header = getHeader(user_id, farm_id);

  try {
    const result = yield call(axios.delete, `${locationURL}/${location_id}`, header);
    yield put(deleteFenceSuccess(location_id));
    yield put(invalidateTags(['Locations']));
    yield put(
      setSuccessMessage([
        i18n.t('FARM_MAP.MAP_FILTER.FENCE'),
        i18n.t('message:MAP.SUCCESS_DELETE'),
      ]),
    );
    yield put(canShowSuccessHeader(true));
    history.push({ pathname: '/map' });
  } catch (e) {
    history.push(
      {
        pathname: history.location.pathname,
      },
      {
        error: {
          retire: true,
        },
      },
    );
    console.log(e);
  }
}

export default function* fenceLocationSaga() {
  yield takeLeading(postFenceLocation.type, postFenceLocationSaga);
  yield takeLeading(editFenceLocation.type, editFenceLocationSaga);
  yield takeLeading(deleteFenceLocation.type, deleteFenceLocationSaga);
}
